export const INTUIT_AUTH_URL = "INTUIT_AUTH_URL";
export const INTUIT_LOADING = "INTUIT_LOADING";
export const INTUIT_BUSINESS = "INTUIT_BUSINESS";
